import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const contacts = () => import('./contacts');
const locations = () => import('./locations');

/** Top-level pages (inside the app shell). */
export const routes: RouteObject[] = [
  { path: 'organizations', lazy: page(() => import('./organizations-page'), (m) => m.OrganizationsPage) },
  { path: 'contacts', lazy: page(contacts, (m) => m.ContactsPage) },
];

/** Pages inside an organization (children of /organizations/:orgId). */
export const orgRoutes: RouteObject[] = [
  { index: true, lazy: page(() => import('./org-overview'), (m) => m.OrgOverviewPage) },
  { path: 'contacts', lazy: page(contacts, (m) => m.OrgContactsPage) },
  { path: 'contacts/:contactId', lazy: page(contacts, (m) => m.ContactPage) },
  { path: 'locations', lazy: page(locations, (m) => m.OrgLocationsPage) },
  { path: 'locations/:locationId', lazy: page(locations, (m) => m.LocationPage) },
  { path: 'activity', lazy: page(() => import('./org-activity'), (m) => m.OrgActivityPage) },
];
